'use client';

import { useCallback } from 'react';
import { popup, type ShowPopupOptions } from '../bootstrap/tmaActions';
import { useCapability } from '../runtime/useCapability';
import { hasConfirmDialogHost, openConfirmDialog } from '../stores/confirmDialogStore';
import { confirmButtons, dismissAnswer, isRefusalButton } from '../components/ConfirmDialog/confirmAnswer';

export type { ShowPopupOptions, ShowPopupOptionsButton } from '../bootstrap/tmaActions';

function nativeAnswer(options: ShowPopupOptions): string | null {
  if (typeof window === 'undefined') return dismissAnswer(options);
  const text = options.title ? `${options.title}\n\n${options.message}` : options.message;
  const buttons = confirmButtons(options);
  if (buttons.length <= 1) {
    window.alert(text);
    return dismissAnswer(options);
  }
  const accept = buttons.find((b) => !isRefusalButton(b));
  return window.confirm(text) ? (accept?.id ?? 'confirm') : dismissAnswer(options);
}

export function useConfirmPopup() {
  const hasTelegramPopup = useCapability('tmaConfirmPopup');

  return useCallback(
    async (options: ShowPopupOptions): Promise<string | null> => {
      if (hasTelegramPopup) {
        try {
          const answer = await popup.open(options);
          if (answer !== undefined) return answer;
        } catch (err) {
          console.warn('[useConfirmPopup] Telegram popup failed, falling back', err);
        }
      }

      if (!hasConfirmDialogHost()) return nativeAnswer(options);
      return await openConfirmDialog(options);
    },
    [hasTelegramPopup],
  );
}
